import { render, staticRenderFns } from "./UserContract.vue?vue&type=template&id=2fe15e6a"
import script from "./UserContract.js?vue&type=script&lang=js&external"
export * from "./UserContract.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports